"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../atoms/Text"));
var _flexComponents = require("../atoms/flex-components");
var _jsxRuntime = require("react/jsx-runtime");
var LabelOverComponent = function LabelOverComponent(_ref) {
  var label = _ref.label,
    children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flexComponents.FlexColumn, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      type: 'utility',
      variant: 'overline',
      color: 'secondary',
      children: label
    }), children]
  });
};
LabelOverComponent.defaultProps = {
  label: 'Label'
};
var _default = exports.default = LabelOverComponent;